var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29488 13.8332H2.32532L10.0417 6.1168L9.01128 5.08634L1.29488 12.8027V13.8332ZM12.7147 5.21297L9.90228 2.42616L10.9968 1.33161C11.2361 1.09231 11.531 0.972656 11.8814 0.972656C12.2318 0.972656 12.5267 1.09231 12.766 1.33161L13.7964 2.36205C14.0358 2.60136 14.1597 2.89195 14.1682 3.23382C14.1768 3.5757 14.0614 3.86629 13.8221 4.10559L12.7147 5.21297ZM0.798109 15.0832C0.583373 15.0832 0.404158 15.0113 0.260463 14.8676C0.116769 14.7239 0.0449219 14.5447 0.0449219 14.3299V12.5848C0.0449219 12.4844 0.0630814 12.3888 0.0994008 12.2979C0.13572 12.2071 0.19288 12.1227 0.27088 12.0447L8.99844 3.31716L11.8109 6.12962L3.08332 14.8572C3.00533 14.9352 2.92094 14.9923 2.83013 15.0287C2.73931 15.065 2.64369 15.0832 2.54325 15.0832H0.798109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrange);
export default __webpack_public_path__ + "static/media/edit_orange.c72399427dd92f6a6034413139a975d9.svg";
export { ForwardRef as ReactComponent };